'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    AnimateOnClick: ()=>AnimateOnClick
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
var external_react_default = /*#__PURE__*/ __webpack_require__.n(external_react_namespaceObject);
const index_cjs_namespaceObject = require("../../../utils/index.cjs");
const AnimateOnClick = ({ children })=>{
    const iconRef = (0, external_react_namespaceObject.useRef)(null);
    const handleMouseDown = (0, external_react_namespaceObject.useCallback)(()=>{
        iconRef.current?.startAnimation();
    }, [
        iconRef
    ]);
    const handleMouseLeave = (0, external_react_namespaceObject.useCallback)(()=>{
        iconRef.current?.stopAnimation();
    }, [
        iconRef
    ]);
    return external_react_default().Children.map(children, (child)=>/*#__PURE__*/ external_react_default().isValidElement(child) && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(child.type, {
            ...child.props,
            ref: iconRef,
            onMouseDown: handleMouseDown,
            onMouseLeave: handleMouseLeave,
            className: (0, index_cjs_namespaceObject.cn)('cursor-pointer', child.props.className)
        }));
};
exports.AnimateOnClick = __webpack_exports__.AnimateOnClick;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "AnimateOnClick"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
